import IField, {FieldBehaviors, FieldType} from "../IField";
import ArrayField from "./ArrayField";
import EnumField from "./EnumField";
import ImageField from "./ImageField";
import LengthIntervalField from "./LengthIntervalField";
import TextField from "./TextField";
import BooleanField from "./BooleanField";

export default class FieldFactory {
    public static deserialize(input : any) : IField {
        switch (input.type.toUpperCase() as FieldType) {
            case FieldType.Array:
                const innerField = FieldFactory.deserialize(input.innerField);
                return new ArrayField(input.id, input.name, innerField.order, innerField, input.nullable, FieldFactory.deserializeFieldBehaviour(input.behaviors));
            case FieldType.Enum:
                return new EnumField(input.id, input.name, input.options, input.order, input.multiple, input.searchable, input.nullable, FieldFactory.deserializeFieldBehaviour(input.behaviors));
            case FieldType.Image:
                return new ImageField(input.id, input.name, input.baseUrl, input.order, input.nullable, FieldFactory.deserializeFieldBehaviour(input.behaviors));
            case FieldType.LengthInterval:
                return new LengthIntervalField(input.id, input.name, input.searchable, input.order, input.nullable, 'cm', 'm', FieldFactory.deserializeFieldBehaviour(input.behaviors));
            case FieldType.Text:
                return new TextField(input.id, input.name, input.order, input.searchable, input.nullable, FieldFactory.deserializeFieldBehaviour(input.behaviors));
            case FieldType.Boolean:
                return new BooleanField(input.id, input.name, input.order, input.searchable, FieldFactory.deserializeFieldBehaviour(input));
            default:
                throw new Error("Unknown type");
        }
    }

    private static deserializeFieldBehaviour(input : string[]) : FieldBehaviors {
        let result = FieldBehaviors.None;
        for (const val of input) {
            result |= FieldBehaviors[val] as FieldBehaviors;
        }
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/metamodel/Fields/FieldFactory.ts